export var XpCategory;
(function (XpCategory) {
    XpCategory[XpCategory["Player"] = -1] = "Player";
    XpCategory[XpCategory["Market"] = -2] = "Market";
    XpCategory[XpCategory["Adventure"] = -3] = "Adventure";
})(XpCategory || (XpCategory = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/market/XpCategory.ts
// module id = 1890
// module chunks = 3